import { useState } from 'react';
import { createJobPayment } from '../api/jobPayments';
import type { CreateJobPaymentRequest, JobPayment } from '../types/jobPayment';

/**
 * Hook for creating a new job payment
 */
export function useCreateJobPayment() {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (
    jobId: number,
    data: CreateJobPaymentRequest
  ): Promise<JobPayment | null> => {
    setIsCreating(true);
    setError(null);
    try {
      const payment = await createJobPayment(jobId, data);
      return payment;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to create job payment');
      return null;
    } finally {
      setIsCreating(false);
    }
  };

  return {
    create,
    isCreating,
    error,
  };
}
